// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"32":"porque-investir-em-mt","265":"main-contato","328":"trabalhe-conosco","507":"setores-para-investir","792":"incentivos-para-quem-investe-em-mt","942":"main-footer"}[chunkId] + "." + {"32":"fef71657","265":"f5d39a5c","328":"736f1bfa","507":"899a6fc1","792":"75694412","942":"611408b2"}[chunkId] + ".css";
};